import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import RegMain from "../../components/regMain";



const RegPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Регистрация')}/>
            <RegMain/>
        </section>
    );
};

export default RegPage;